// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 100%;
  overflow: hidden;
}

@media (max-width: 767px) {
  .custom-small-size {
    display: none;
    visibility: hidden;
  }
}
@media (max-width: 767px) {
  .sideMenuIcon {
    display: block !important;
    visibility: visible;
  }
  .sideMenuIcon i {
    font-size: 2.5rem;
  }
  .navLinksStyle {
    text-align: center;
  }
  .navLinksStyle .list {
    margin-bottom: 8px;
  }
  .navLinksStyle .list a {
    font-size: 14px;
  }
  .Offcanvas {
    width: 80%;
  }
}
@media (max-width: 767px) {
  html {
    font-size: 70%;
  }
  body {
    font-size: 14px;
  }
  .container {
    padding: 10px;
  }
  .card {
    margin-bottom: 15px;
  }
  .btn {
    font-size: 12px;
  }
  .homeHeaderSectionContainer .homeHeaderContainer .rows {
    display: flex;
    flex-direction: column-reverse;
  }
  .homeHeaderSectionContainer .homeHeaderContainer .rows .leftCol {
    display: flex;
    justify-content: center;
    place-items: center;
  }
  .homeHeaderSectionContainer .homeHeaderContainer .rows .leftCol .homeLeftHeader {
    text-align: center;
  }
  .aboutSectionContainer {
    padding: 5% 0;
  }
  .aboutSectionContainer .aboutSection .rows .imgContainer,
  .aboutSectionContainer .aboutSection .rows .txtContainer {
    text-align: center;
  }
  .aboutSectionContainer .aboutSection .rows .imgContainer h3,
  .aboutSectionContainer .aboutSection .rows .imgContainer h2,
  .aboutSectionContainer .aboutSection .rows .imgContainer h4,
  .aboutSectionContainer .aboutSection .rows .txtContainer h3,
  .aboutSectionContainer .aboutSection .rows .txtContainer h2,
  .aboutSectionContainer .aboutSection .rows .txtContainer h4 {
    font-size: 1.5rem;
  }
  .aboutSectionContainer .aboutSection .rows .imgContainer p,
  .aboutSectionContainer .aboutSection .rows .txtContainer p {
    font-size: 1rem;
  }
  .cardSectionContainer .tab-container .btn-group {
    display: flex;
    margin: 0 20px 0 0 !important;
    padding: 20px !important;
  }
  .cardSectionContainer .tab-container .btn-group .btn {
    padding: 20px !important;
    margin-bottom: 0 !important;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content {
    display: flex;
    flex-direction: column;
    font-size: 1.1rem;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content .contentBtn {
    width: 100%;
    text-align: left;
    padding: 0 !important;
    margin: 0 !important;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content .tabInnerContent {
    padding-top: 5px;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content .tabInnerContent h4,
  .cardSectionContainer .tab-container .btn-group .btn .button-content .tabInnerContent h1 {
    line-height: 11px !important;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content .tabInnerContent p {
    text-align: justify;
  }
  .cardSectionContainer .tab-container .btn-group .btn img {
    max-width: 40px !important;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows {
    display: inline-flex !important;
    justify-content: center;
    overflow: scroll;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner {
    width: -moz-fit-content;
    width: fit-content;
    padding: 10px 10px;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard {
    padding: 20px;
    margin: 0 0 0 0;
    border-radius: 10px;
    box-shadow: none;
    transition: all 0.3s ease-in-out;
    border: 2px dotted #eee;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard h3 {
    padding-top: 2%;
    font-weight: 700;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard h6 {
    color: #3fb9ea;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard p {
    color: #7c7c7c;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard:hover {
    border: 2px solid #fff;
    box-shadow: 2px 2px 20px 10px #b9b9b9;
  }
  .chooseSectionContainer .chooseSection .chooseSectionRows {
    display: flex;
    flex-direction: column-reverse;
  }
  .chooseSectionContainer .chooseSection .chooseSectionRows .innerCard {
    margin-top: 10px;
    text-align: center;
  }
  .dematAccountContainer .formContainer .inputs {
    display: flex;
    flex-direction: column;
  }
  .dematAccountContainer .formContainer .btn {
    width: 100% !important;
  }
  .dematAccountContainer .formContainer .btn .button {
    width: 100% !important;
  }
  .whySectionContainer .whyCards {
    display: flex;
    flex-direction: column;
  }
  .whySectionContainer .whyCards .whyCard {
    padding: 6%;
    width: 100% !important;
  }
  .usefulLinksContainer {
    display: flex;
    justify-content: center;
    color: #ecf0f1;
  }
  .usefulLinksContainer span {
    font-size: 1rem;
  }
  .usefulLinksContainer ul {
    overflow: scroll;
    display: flex;
    list-style-type: none;
    margin: 0;
  }
  .usefulLinksContainer ul li {
    padding: 0 10px;
  }
  .usefulLinksContainer ul li a {
    color: #ecf0f1;
    text-decoration: none;
    font-size: 1rem;
  }
  .usefulLinksContainer ul li a:hover {
    color: #bd0000;
  }
  .usefulLinksContainer ::-webkit-scrollbar {
    width: 0;
  }
  .usefulLinksContainer ::-webkit-scrollbar-track {
    background: transparent;
  }
  .usefulLinksContainer ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0;
  }
  .investroGrievance {
    width: 100%;
    overflow: hidden;
  }
  .investroGrievance .EscalationTableContainer {
    width: 100%;
    overflow: scroll;
  }
  .investroGrievance ::-webkit-scrollbar {
    width: 0;
  }
  .investroGrievance ::-webkit-scrollbar-track {
    background: transparent;
  }
  .investroGrievance ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0;
  }
}
.complianceOfficer {
  width: 100%;
  overflow: hidden;
}
.complianceOfficer .complianceOfficerDataTable {
  width: 100%;
  overflow: scroll;
}
.complianceOfficer ::-webkit-scrollbar {
  width: 0;
}
.complianceOfficer ::-webkit-scrollbar-track {
  background: transparent;
}
.complianceOfficer ::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 0;
}

@media (min-width: 768px) and (max-width: 1024px) {
  html {
    font-size: 70%;
  }
  .container {
    padding: 10px;
  }
  .card {
    margin-bottom: 15px;
  }
  .btn {
    font-size: 12px;
  }
  .custom-small-size {
    display: none;
    visibility: hidden;
  }
  .sideMenuIcon {
    display: block !important;
    visibility: visible;
  }
  .sideMenuIcon i {
    font-size: 2.5rem;
  }
  .navLinksStyle {
    text-align: center;
  }
  .navLinksStyle .list {
    margin-bottom: 8px;
  }
  .navLinksStyle .list a {
    font-size: 14px;
  }
  .Offcanvas {
    width: 80%;
  }
  .aboutSectionContainer {
    padding: 5% 0;
  }
  .aboutSectionContainer .aboutSection .rows .imgContainer,
  .aboutSectionContainer .aboutSection .rows .txtContainer {
    text-align: center;
  }
  .aboutSectionContainer .aboutSection .rows .imgContainer h3,
  .aboutSectionContainer .aboutSection .rows .imgContainer h2,
  .aboutSectionContainer .aboutSection .rows .imgContainer h4,
  .aboutSectionContainer .aboutSection .rows .txtContainer h3,
  .aboutSectionContainer .aboutSection .rows .txtContainer h2,
  .aboutSectionContainer .aboutSection .rows .txtContainer h4 {
    font-size: 1.5rem;
  }
  .aboutSectionContainer .aboutSection .rows .imgContainer p,
  .aboutSectionContainer .aboutSection .rows .txtContainer p {
    font-size: 1rem;
  }
  .cardSectionContainer .tab-container .btn-group {
    display: flex;
    margin-left: 25px !important;
    padding: 20px !important;
  }
  .cardSectionContainer .tab-container .btn-group .btn {
    padding: 20px !important;
    margin-bottom: 0 !important;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content {
    display: flex;
    flex-direction: column;
    font-size: 1.1rem;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content .contentBtn {
    width: 100%;
    text-align: left;
    padding: 0 !important;
    margin: 0 !important;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content .tabInnerContent {
    padding-top: 5px;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content .tabInnerContent h4,
  .cardSectionContainer .tab-container .btn-group .btn .button-content .tabInnerContent h1 {
    line-height: 11px !important;
  }
  .cardSectionContainer .tab-container .btn-group .btn .button-content .tabInnerContent p {
    text-align: justify;
  }
  .cardSectionContainer .tab-container .btn-group .btn img {
    max-width: 40px !important;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows {
    display: inline-flex !important;
    justify-content: center;
    overflow: scroll;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner {
    width: -moz-fit-content;
    width: fit-content;
    padding: 10px 10px;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard {
    padding: 20px;
    margin: 0 0 0 0;
    border-radius: 10px;
    box-shadow: none;
    transition: all 0.3s ease-in-out;
    border: 2px dotted #eee;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard h3 {
    padding-top: 2%;
    font-weight: 700;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard h6 {
    color: #3fb9ea;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard p {
    color: #7c7c7c;
  }
  .cardSectionContainer .tab-content .tab-content-inner .card-container .card-container-rows .tabCardInner .tabCard:hover {
    border: 2px solid #fff;
    box-shadow: 2px 2px 20px 10px #b9b9b9;
  }
  .chooseSectionContainer .chooseSection .chooseSectionRowsOuter {
    display: flex;
    flex-direction: column-reverse;
  }
  .chooseSectionContainer .chooseSection .chooseSectionRowsOuter .innerCard {
    margin-top: 10px;
  }
  .chooseSectionContainer .chooseSection .chooseSectionRowsOuter .innerCard .txtContainer {
    text-align: left;
  }
  .chooseSectionContainer .chooseSection .chooseSectionRowsOuter .innerCard .txtContainer .btns {
    display: flex;
    left: 0;
  }
  .dematAccountContainer .formContainer .inputs {
    display: flex;
    flex-direction: column;
  }
  .dematAccountContainer .formContainer .btn {
    width: 100% !important;
  }
  .dematAccountContainer .formContainer .btn .button {
    width: 100% !important;
  }
  .whySectionContainer .whyCards .whyCard {
    padding: 6%;
  }
  .usefulLinksContainer {
    display: flex;
    justify-content: center;
    color: #ecf0f1;
  }
  .usefulLinksContainer span {
    font-size: 1rem;
  }
  .usefulLinksContainer ul {
    overflow: scroll;
    display: flex;
    list-style-type: none;
    margin: 0;
  }
  .usefulLinksContainer ul li {
    padding: 0 10px;
  }
  .usefulLinksContainer ul li a {
    color: #ecf0f1;
    text-decoration: none;
    font-size: 1rem;
  }
  .usefulLinksContainer ul li a:hover {
    color: #bd0000;
  }
  .usefulLinksContainer ::-webkit-scrollbar {
    width: 0;
  }
  .usefulLinksContainer ::-webkit-scrollbar-track {
    background: transparent;
  }
  .usefulLinksContainer ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0;
  }
  .investroGrievance {
    width: 100%;
    overflow: hidden;
  }
  .investroGrievance .EscalationTableContainer {
    width: 100%;
    overflow: scroll;
  }
  .investroGrievance ::-webkit-scrollbar {
    width: 0;
  }
  .investroGrievance ::-webkit-scrollbar-track {
    background: transparent;
  }
  .investroGrievance ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Assets/Css/Styles.scss"],"names":[],"mappings":"AAOA;EACI,WAAA;EACA,gBAAA;AANJ;;AAYA;EACI;IACI,aAAA;IACA,kBAAA;EATN;AACF;AAaA;EACI;IACI,yBAAA;IACA,mBAAA;EAXN;EAaM;IACI,iBAAA;EAXV;EAcE;IACI,kBAAA;EAZN;EAcM;IACI,kBAAA;EAZV;EAcU;IACI,eAAA;EAZd;EAiBE;IACI,UAAA;EAfN;AACF;AAoBA;EACI;IACI,cAAA;EAlBN;EAqBE;IACI,eAAA;EAnBN;EAsBE;IACI,aAAA;EApBN;EAuBE;IACI,mBAAA;EArBN;EAwBE;IACI,eAAA;EAtBN;EA6BU;IACI,aAAA;IACA,8BAAA;EA3Bd;EA6Bc;IACI,aAAA;IACA,uBAAA;IACA,mBAAA;EA3BlB;EA6BkB;IACI,kBAAA;EA3BtB;EAmCE;IACI,aAAA;EAjCN;EAqCc;;IAEI,kBAAA;EAnClB;EAqCkB;;;;;;IAGI,iBAAA;EAhCtB;EAmCkB;;IACI,eAAA;EAhCtB;EA0CU;IACI,aAAA;IACA,6BAAA;IACA,wBAAA;EAxCd;EA0Cc;IACI,wBAAA;IACA,2BAAA;EAxClB;EA0CkB;IACI,aAAA;IACA,sBAAA;IACA,iBAAA;EAxCtB;EA0CsB;IACI,WAAA;IACA,gBAAA;IACA,qBAAA;IACA,oBAAA;EAxC1B;EA2CsB;IACI,gBAAA;EAzC1B;EA0C0B;;IAEI,4BAAA;EAxC9B;EA2C0B;IACI,mBAAA;EAzC9B;EA8CkB;IACI,0BAAA;EA5CtB;EAqDkB;IACI,+BAAA;IACA,uBAAA;IACA,gBAAA;EAnDtB;EAqDsB;IACI,uBAAA;IAAA,kBAAA;IACA,kBAAA;EAnD1B;EAqD0B;IACI,aAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,gCAAA;IACA,uBAAA;EAnD9B;EAqD8B;IACI,eAAA;IACA,gBAAA;EAnDlC;EAsD8B;IACI,cA1L1B;EAsIR;EAuD8B;IACI,cAAA;EArDlC;EAwD8B;IACI,sBAAA;IACA,qCAAA;EAtDlC;EAqEU;IACI,aAAA;IACA,8BAAA;EAnEd;EAqEc;IACI,gBAAA;IACA,kBAAA;EAnElB;EA4EU;IACI,aAAA;IACA,sBAAA;EA1Ed;EA6EU;IACI,sBAAA;EA3Ed;EA6Ec;IACI,sBAAA;EA3ElB;EAmFM;IACI,aAAA;IACA,sBAAA;EAjFV;EAmFU;IACI,WAAA;IACA,sBAAA;EAjFd;EAuFE;IACI,aAAA;IACA,uBAAA;IACA,cAAA;EArFN;EAuFM;IACI,eAAA;EArFV;EAwFM;IACI,gBAAA;IACA,aAAA;IACA,qBAAA;IACA,SAAA;EAtFV;EAwFU;IACI,eAAA;EAtFd;EAwFc;IACI,cAAA;IACA,qBAAA;IACA,eAAA;EAtFlB;EAwFkB;IACI,cAAA;EAtFtB;EA6FM;IACI,QAAA;EA3FV;EA8FM;IACI,uBAAA;EA5FV;EA+FM;IACI,uBAAA;IACA,gBAAA;EA7FV;EAkGE;IACI,WAAA;IACA,gBAAA;EAhGN;EAkGM;IACI,WAAA;IACA,gBAAA;EAhGV;EAoGM;IACI,QAAA;EAlGV;EAqGM;IACI,uBAAA;EAnGV;EAsGM;IACI,uBAAA;IACA,gBAAA;EApGV;AACF;AAyGA;EACI,WAAA;EACA,gBAAA;AAvGJ;AAyGI;EACI,WAAA;EACA,gBAAA;AAvGR;AA2GI;EACI,QAAA;AAzGR;AA4GI;EACI,uBAAA;AA1GR;AA6GI;EACI,uBAAA;EACA,gBAAA;AA3GR;;AAqIA;EACI;IACI,cAAA;EAlIN;EAqIE;IACI,aAAA;EAnIN;EAsIE;IACI,mBAAA;EApIN;EAuIE;IACI,eAAA;EArIN;EAyIE;IACI,aAAA;IACA,kBAAA;EAvIN;EA0IE;IACI,yBAAA;IACA,mBAAA;EAxIN;EA0IM;IACI,iBAAA;EAxIV;EA2IE;IACI,kBAAA;EAzIN;EA2IM;IACI,kBAAA;EAzIV;EA2IU;IACI,eAAA;EAzId;EA8IE;IACI,UAAA;EA5IN;EAkJE;IACI,aAAA;EAhJN;EAoJc;;IAEI,kBAAA;EAlJlB;EAoJkB;;;;;;IAGI,iBAAA;EA/ItB;EAkJkB;;IACI,eAAA;EA/ItB;EAyJU;IACI,aAAA;IACA,4BAAA;IACA,wBAAA;EAvJd;EAyJc;IACI,wBAAA;IACA,2BAAA;EAvJlB;EAyJkB;IACI,aAAA;IACA,sBAAA;IACA,iBAAA;EAvJtB;EAyJsB;IACI,WAAA;IACA,gBAAA;IACA,qBAAA;IACA,oBAAA;EAvJ1B;EA0JsB;IACI,gBAAA;EAxJ1B;EAyJ0B;;IAEI,4BAAA;EAvJ9B;EA0J0B;IACI,mBAAA;EAxJ9B;EA6JkB;IACI,0BAAA;EA3JtB;EAoKkB;IACI,+BAAA;IACA,uBAAA;IACA,gBAAA;EAlKtB;EAoKsB;IACI,uBAAA;IAAA,kBAAA;IACA,kBAAA;EAlK1B;EAoK0B;IACI,aAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,gCAAA;IACA,uBAAA;EAlK9B;EAoK8B;IACI,eAAA;IACA,gBAAA;EAlKlC;EAqK8B;IACI,cAngB1B;EAgWR;EAsK8B;IACI,cAAA;EApKlC;EAuK8B;IACI,sBAAA;IACA,qCAAA;EArKlC;EAoLU;IACI,aAAA;IACA,8BAAA;EAlLd;EAoLc;IACI,gBAAA;EAlLlB;EAqLkB;IACI,gBAAA;EAnLtB;EAqLsB;IACI,aAAA;IACA,OAAA;EAnL1B;EA+LU;IACI,aAAA;IACA,sBAAA;EA7Ld;EAgMU;IACI,sBAAA;EA9Ld;EAgMc;IACI,sBAAA;EA9LlB;EAwMU;IACI,WAAA;EAtMd;EA4ME;IACI,aAAA;IACA,uBAAA;IACA,cAAA;EA1MN;EA4MM;IACI,eAAA;EA1MV;EA6MM;IACI,gBAAA;IACA,aAAA;IACA,qBAAA;IACA,SAAA;EA3MV;EA6MU;IACI,eAAA;EA3Md;EA6Mc;IACI,cAAA;IACA,qBAAA;IACA,eAAA;EA3MlB;EA6MkB;IACI,cAAA;EA3MtB;EAkNM;IACI,QAAA;EAhNV;EAmNM;IACI,uBAAA;EAjNV;EAoNM;IACI,uBAAA;IACA,gBAAA;EAlNV;EAuNE;IACI,WAAA;IACA,gBAAA;EArNN;EAuNM;IACI,WAAA;IACA,gBAAA;EArNV;EAyNM;IACI,QAAA;EAvNV;EA0NM;IACI,uBAAA;EAxNV;EA2NM;IACI,uBAAA;IACA,gBAAA;EAzNV;AACF","sourcesContent":["// Color Variables\r\n$primary: #3fb9ea;\r\n$secondary: #d60000;\r\n$hover: #b80000;\r\n$gray: #808080;\r\n\r\n// ?? Global Css Here\r\n.wrapper {\r\n    width: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n// ********** Media query for small devices (up to 767px width) *********\r\n// ?? Navs\r\n// *** Top Nav\r\n@media (max-width: 767px) {\r\n    .custom-small-size {\r\n        display: none;\r\n        visibility: hidden;\r\n    }\r\n}\r\n\r\n// *** Top Side Nav\r\n@media (max-width: 767px) {\r\n    .sideMenuIcon {\r\n        display: block !important;\r\n        visibility: visible;\r\n\r\n        i {\r\n            font-size: 2.5rem;\r\n        }\r\n    }\r\n    .navLinksStyle {\r\n        text-align: center;\r\n\r\n        .list {\r\n            margin-bottom: 8px;\r\n\r\n            a {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .Offcanvas {\r\n        width: 80%;\r\n    }\r\n}\r\n\r\n// ***** Styling for content\r\n// Styling for content on small screens (Mobile) (max-width: 767px)\r\n@media (max-width: 767px) {\r\n    html {\r\n        font-size: 70%;\r\n    }\r\n\r\n    body {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .container {\r\n        padding: 10px;\r\n    }\r\n\r\n    .card {\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .btn {\r\n        font-size: 12px;\r\n    }\r\n\r\n    // ********************* Home Page ************************\r\n    // *** Header Section\r\n    .homeHeaderSectionContainer {\r\n        .homeHeaderContainer {\r\n            .rows {\r\n                display: flex;\r\n                flex-direction: column-reverse;\r\n\r\n                .leftCol {\r\n                    display: flex;\r\n                    justify-content: center;\r\n                    place-items: center;\r\n\r\n                    .homeLeftHeader {\r\n                        text-align: center;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** About Section\r\n    .aboutSectionContainer {\r\n        padding: 5% 0;\r\n\r\n        .aboutSection {\r\n            .rows {\r\n                .imgContainer,\r\n                .txtContainer {\r\n                    text-align: center;\r\n\r\n                    h3,\r\n                    h2,\r\n                    h4 {\r\n                        font-size: 1.5rem;\r\n                    }\r\n\r\n                    p {\r\n                        font-size: 1rem;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Trader Section\r\n    .cardSectionContainer {\r\n        .tab-container {\r\n            .btn-group {\r\n                display: flex;\r\n                margin: 0 20px 0 0 !important;\r\n                padding: 20px !important;\r\n\r\n                .btn {\r\n                    padding: 20px !important;\r\n                    margin-bottom: 0 !important;\r\n\r\n                    .button-content {\r\n                        display: flex;\r\n                        flex-direction: column;\r\n                        font-size: 1.1rem;\r\n\r\n                        .contentBtn {\r\n                            width: 100%;\r\n                            text-align: left;\r\n                            padding: 0 !important;\r\n                            margin: 0 !important;\r\n                        }\r\n\r\n                        .tabInnerContent {\r\n                            padding-top: 5px;\r\n                            h4,\r\n                            h1 {\r\n                                line-height: 11px !important;\r\n                            }\r\n    \r\n                            p {\r\n                                text-align: justify;\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    img {\r\n                        max-width: 40px !important;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .tab-content {\r\n            .tab-content-inner {\r\n                .card-container {\r\n                    .card-container-rows {\r\n                        display: inline-flex !important;\r\n                        justify-content: center;\r\n                        overflow: scroll;\r\n\r\n                        .tabCardInner {\r\n                            width: fit-content;\r\n                            padding: 10px 10px;\r\n                            \r\n                            .tabCard {\r\n                                padding: 20px;\r\n                                margin: 0 0 0 0;\r\n                                border-radius: 10px;\r\n                                box-shadow: none;\r\n                                transition: all 0.3s ease-in-out;\r\n                                border: 2px dotted #eee;\r\n        \r\n                                h3 {\r\n                                    padding-top: 2%;\r\n                                    font-weight: 700;\r\n                                }\r\n        \r\n                                h6 {\r\n                                    color: $primary;\r\n                                }\r\n        \r\n                                p {\r\n                                    color: #7c7c7c;\r\n                                }\r\n        \r\n                                &:hover {\r\n                                    border: 2px solid #fff;\r\n                                    box-shadow: 2px 2px 20px 10px #b9b9b9;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n\r\n\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Choose Cards ***\r\n    .chooseSectionContainer {\r\n        .chooseSection {\r\n            .chooseSectionRows {\r\n                display: flex;\r\n                flex-direction: column-reverse;\r\n\r\n                .innerCard {\r\n                    margin-top: 10px;\r\n                    text-align: center;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Demat Account ***\r\n    .dematAccountContainer {\r\n        .formContainer {\r\n            .inputs {\r\n                display: flex;\r\n                flex-direction: column;\r\n            }\r\n\r\n            .btn {\r\n                width: 100% !important;\r\n\r\n                .button {\r\n                    width: 100% !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Why Section ***\r\n    .whySectionContainer {\r\n        .whyCards {\r\n            display: flex;\r\n            flex-direction: column;\r\n\r\n            .whyCard {\r\n                padding: 6%;\r\n                width: 100% !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Footers ***\r\n    .usefulLinksContainer {\r\n        display: flex;\r\n        justify-content: center;\r\n        color: #ecf0f1;\r\n\r\n        span {\r\n            font-size: 1rem;\r\n        }\r\n\r\n        ul {\r\n            overflow: scroll;\r\n            display: flex;\r\n            list-style-type: none;\r\n            margin: 0;\r\n\r\n            li {\r\n                padding: 0 10px;\r\n\r\n                a {\r\n                    color: #ecf0f1;\r\n                    text-decoration: none;\r\n                    font-size: 1rem;\r\n\r\n                    &:hover {\r\n                        color: darken($secondary, 5%);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        // *** Scrolls ***\r\n        ::-webkit-scrollbar {\r\n            width: 0;\r\n        }\r\n\r\n        ::-webkit-scrollbar-track {\r\n            background: transparent;\r\n        }\r\n\r\n        ::-webkit-scrollbar-thumb {\r\n            background: transparent;\r\n            border-radius: 0;\r\n        }\r\n    }\r\n    \r\n    // *** Contact Page\r\n    .investroGrievance {\r\n        width: 100%;\r\n        overflow: hidden;\r\n        \r\n        .EscalationTableContainer {\r\n            width: 100%;\r\n            overflow: scroll;\r\n        }\r\n        \r\n        // *** Scrolls ***\r\n        ::-webkit-scrollbar {\r\n            width: 0;\r\n        }\r\n    \r\n        ::-webkit-scrollbar-track {\r\n            background: transparent;\r\n        }\r\n    \r\n        ::-webkit-scrollbar-thumb {\r\n            background: transparent;\r\n            border-radius: 0;\r\n        }\r\n    }\r\n}\r\n\r\n// *** Compliance Section Contact Page  \r\n.complianceOfficer {\r\n    width: 100%;\r\n    overflow: hidden;\r\n    \r\n    .complianceOfficerDataTable {\r\n        width: 100%;\r\n        overflow: scroll;\r\n    }\r\n    \r\n    // *** Scrolls ***\r\n    ::-webkit-scrollbar {\r\n        width: 0;\r\n    }\r\n    \r\n    ::-webkit-scrollbar-track {\r\n        background: transparent;\r\n    }\r\n    \r\n    ::-webkit-scrollbar-thumb {\r\n        background: transparent;\r\n        border-radius: 0;\r\n    }\r\n}\r\n\r\n// ?? Ends ✔\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n// ********** Tablet size screens\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n    html {\r\n        font-size: 70%;\r\n    }\r\n\r\n    .container {\r\n        padding: 10px;\r\n    }\r\n\r\n    .card {\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .btn {\r\n        font-size: 12px;\r\n    }\r\n\r\n    // ******************** Defaults **************************\r\n    .custom-small-size {\r\n        display: none;\r\n        visibility: hidden;\r\n    }\r\n\r\n    .sideMenuIcon {\r\n        display: block !important;\r\n        visibility: visible;\r\n\r\n        i {\r\n            font-size: 2.5rem;\r\n        }\r\n    }\r\n    .navLinksStyle {\r\n        text-align: center;\r\n\r\n        .list {\r\n            margin-bottom: 8px;\r\n\r\n            a {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .Offcanvas {\r\n        width: 80%;\r\n    }\r\n\r\n    // ********************* Home Page ************************\r\n\r\n    // *** About Section\r\n    .aboutSectionContainer {\r\n        padding: 5% 0;\r\n\r\n        .aboutSection {\r\n            .rows {\r\n                .imgContainer,\r\n                .txtContainer {\r\n                    text-align: center;\r\n\r\n                    h3,\r\n                    h2,\r\n                    h4 {\r\n                        font-size: 1.5rem;\r\n                    }\r\n\r\n                    p {\r\n                        font-size: 1rem;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Trader Section\r\n    .cardSectionContainer {\r\n        .tab-container {\r\n            .btn-group {\r\n                display: flex;\r\n                margin-left: 25px !important;\r\n                padding: 20px !important;\r\n\r\n                .btn {\r\n                    padding: 20px !important;\r\n                    margin-bottom: 0 !important;\r\n\r\n                    .button-content {\r\n                        display: flex;\r\n                        flex-direction: column;\r\n                        font-size: 1.1rem;\r\n\r\n                        .contentBtn {\r\n                            width: 100%;\r\n                            text-align: left;\r\n                            padding: 0 !important;\r\n                            margin: 0 !important;\r\n                        }\r\n\r\n                        .tabInnerContent {\r\n                            padding-top: 5px;\r\n                            h4,\r\n                            h1 {\r\n                                line-height: 11px !important;\r\n                            }\r\n    \r\n                            p {\r\n                                text-align: justify;\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    img {\r\n                        max-width: 40px !important;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .tab-content {\r\n            .tab-content-inner {\r\n                .card-container {\r\n                    .card-container-rows {\r\n                        display: inline-flex !important;\r\n                        justify-content: center;\r\n                        overflow: scroll;\r\n\r\n                        .tabCardInner {\r\n                            width: fit-content;\r\n                            padding: 10px 10px;\r\n                            \r\n                            .tabCard {\r\n                                padding: 20px;\r\n                                margin: 0 0 0 0;\r\n                                border-radius: 10px;\r\n                                box-shadow: none;\r\n                                transition: all 0.3s ease-in-out;\r\n                                border: 2px dotted #eee;\r\n        \r\n                                h3 {\r\n                                    padding-top: 2%;\r\n                                    font-weight: 700;\r\n                                }\r\n        \r\n                                h6 {\r\n                                    color: $primary;\r\n                                }\r\n        \r\n                                p {\r\n                                    color: #7c7c7c;\r\n                                }\r\n        \r\n                                &:hover {\r\n                                    border: 2px solid #fff;\r\n                                    box-shadow: 2px 2px 20px 10px #b9b9b9;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n\r\n\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Choose Cards ***\r\n    .chooseSectionContainer {\r\n        .chooseSection {\r\n            .chooseSectionRowsOuter {\r\n                display: flex;\r\n                flex-direction: column-reverse;\r\n\r\n                .innerCard {\r\n                    margin-top: 10px;\r\n                    // text-align: center;\r\n\r\n                    .txtContainer {\r\n                        text-align: left;\r\n\r\n                        .btns {\r\n                            display: flex;\r\n                            left: 0;\r\n                        }\r\n                    }\r\n\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Demat Account ***\r\n    .dematAccountContainer {\r\n        .formContainer {\r\n            .inputs {\r\n                display: flex;\r\n                flex-direction: column;\r\n            }\r\n\r\n            .btn {\r\n                width: 100% !important;\r\n\r\n                .button {\r\n                    width: 100% !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Why Section ***\r\n    .whySectionContainer {\r\n        .whyCards {\r\n\r\n            .whyCard {\r\n                padding: 6%;\r\n            }\r\n        }\r\n    }\r\n\r\n    // *** Footers ***\r\n    .usefulLinksContainer {\r\n        display: flex;\r\n        justify-content: center;\r\n        color: #ecf0f1;\r\n\r\n        span {\r\n            font-size: 1rem;\r\n        }\r\n\r\n        ul {\r\n            overflow: scroll;\r\n            display: flex;\r\n            list-style-type: none;\r\n            margin: 0;\r\n\r\n            li {\r\n                padding: 0 10px;\r\n\r\n                a {\r\n                    color: #ecf0f1;\r\n                    text-decoration: none;\r\n                    font-size: 1rem;\r\n\r\n                    &:hover {\r\n                        color: darken($secondary, 5%);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        // *** Scrolls ***\r\n        ::-webkit-scrollbar {\r\n            width: 0;\r\n        }\r\n\r\n        ::-webkit-scrollbar-track {\r\n            background: transparent;\r\n        }\r\n\r\n        ::-webkit-scrollbar-thumb {\r\n            background: transparent;\r\n            border-radius: 0;\r\n        }\r\n    }\r\n    \r\n    // *** Contact Page\r\n    .investroGrievance {\r\n        width: 100%;\r\n        overflow: hidden;\r\n        \r\n        .EscalationTableContainer {\r\n            width: 100%;\r\n            overflow: scroll;\r\n        }\r\n        \r\n        // *** Scrolls ***\r\n        ::-webkit-scrollbar {\r\n            width: 0;\r\n        }\r\n    \r\n        ::-webkit-scrollbar-track {\r\n            background: transparent;\r\n        }\r\n    \r\n        ::-webkit-scrollbar-thumb {\r\n            background: transparent;\r\n            border-radius: 0;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
